import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { CacheConstant } from '../../../core/constants/app.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { CmsService } from '../../../core/services/cms.service';

@Component({
  selector: 'par-aem',
  templateUrl: './aem.component.html',
  styleUrls: ['./aem.component.scss']
})
export class AemComponent implements OnInit {
  @Input('template')
  template;
  hyperLinkID: String;
  innerText: string;
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;

  constructor( private elementRef: ElementRef,
    private renderer: Renderer2, private cache: AppCacheService, private cmsService: CmsService) {}

  ngOnInit() {
    this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      if (event.target instanceof HTMLAnchorElement) {
        this.hyperLinkID = event.target.id;
        this.innerText = event.target.innerText;
        if (this.innerText === 'full line of products') {
          window.location.href = this.cache.get(CacheConstant.Static_Data).masterEntityData.find(
            masterData => masterData.key === "PRODUCT_CATALOG_GCP_URL"
          ).value;
        } else if (this.hyperLinkID.startsWith('hyperlink-')) {
          this.hyperLinkID = this.hyperLinkID.replace('hyperlink-', '');
          this.hyperLinkID = this.hyperLinkID.replace('"', '');
          if (this.hyperLinkID) {
            this.cmsService.downloadDocumentFromHashTagNum(this.hyperLinkID);
          }
        }
      }
    });
  }
}
